<template>
  <div>
    <link-input v-model="item.link" :errors="errors.link" />
  </div>
</template>
<script>
export default {
  props: { item: Object, errors: [Object, String, Function] }
}
</script>
